import { useTranslation } from "react-i18next";

import { toast } from "sonner";

import { Plus as Add, Copy as CopyAll } from "lucide-react";
import useErrorListener from "hooks/useErrorListener";

import { useCreateApiKeyMutation } from "api/institutional/router_api";
import { Button } from "components/Shared";
import {
  DialogHeader,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export const CreateApiKey = () => {
  const { t } = useTranslation();

  const [mutate, { error, isLoading, data }] = useCreateApiKeyMutation();

  useErrorListener({ error });

  const doSubmit = () => {
    mutate();
  };

  const handleCopy = (text?: string) => {
    navigator.clipboard.writeText(text ?? "");
    toast.success(t("Copied to clipboard"));
  };

  return (
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{t("Create New Api Key")}</DialogTitle>
      </DialogHeader>
      {data?.api_key ? (
        <span className="font-semibold text-[#968300] text-sm">
          {t(
            "This is the only time you'll be able to view the secret. Make sure to copy and store it securely.",
          )}
        </span>
      ) : (
        <span className="text-sm">
          {t("Click the button to create a new Api Key and Api Secret")}
        </span>
      )}
      {data?.api_key ? (
        <div className="flex gap-2 flex-col">
          <div
            className="flex items-center gap-1 cursor-pointer"
            onClick={() => handleCopy(data?.api_key)}
          >
            <div className="w-full flex flex-col">
              <span className="text-sm font-semibold">Api Key</span>
              <Input
                disabled
                placeholder={t("Api Key")}
                value={data?.api_key}
              />
            </div>
            <button disabled={!data?.api_secret}>
              <CopyAll />
            </button>
          </div>

          <div
            className="flex items-center gap-1 cursor-pointer"
            onClick={() => handleCopy(data?.api_secret)}
          >
            <div className="w-full flex flex-col">
              <span className="text-sm font-semibold">Api Secret</span>
              <Input
                disabled
                placeholder={t("Api Secret")}
                value={data?.api_secret}
              />
            </div>
            <button disabled={!data?.api_secret}>
              <CopyAll />
            </button>
          </div>
        </div>
      ) : null}

      {data?.api_key ? null : (
        <Button className="w-full" disabled={isLoading} onClick={doSubmit}>
          <Add />
          {t("Create Api Key")}
        </Button>
      )}
    </DialogContent>
  );
};

export default CreateApiKey;
